import { useEffect } from 'react'

const useEffectAvailable = (callback, dependancies) => {

	useEffect(() => {
		let ok = true
		dependancies.forEach(dependancy => {
			if (!dependancy) ok = false
		})
		if (ok) callback()
	}, dependancies)
}

export default useEffectAvailable
